// Fallback suppliers for backward compatibility (when API is not available)
export const SUPPLIERS = [
  { id: "63f3596718b7e3cc374a66d3", name: "HSE-KSA" },
  { id: "64662ab9e5bea1cbdfe5a4d4", name: "WNCC" },
  { id: "64d8bd6e0c6946edaf151886", name: "ASLY" },
  { id: "64f046daaeac8ab820f27d93", name: "KZ" },
  // { id: "65c3ac7cf56249162a60ba17", name: "Kawetchagy" },
  { id: "6620e4182a3277f19ea08cd9", name: "Kenya" },
  { id: "6683aa63d71fa531dd60b807", name: "Saint-Gobain" },
  { id: "66a893550c9a818dd757e373", name: "IFT" },
  { id: "66e1b509fab4bf4f37b208d4", name: "Energya-El-Sewedy-Helal" },
  { id: "67a3385e57ad803a5f189854", name: "Sanad" },
  { id: "682464a371ddb4ef1aebd241", name: "ElAseel" },
  { id: "68501135798654d39048af92", name: "AlamalAlsharif" },
  { id: "6a560e64711fa9b2196a6563", name: "RoyalPasta" },
  { id: "6a9ff49e542f5a858bcba219", name: "Ferchem" },
{ id: "67bee56c225fcaef5a783110", name: "ParkVille" }
];

// Cache for fetched suppliers from API
let cachedSuppliers: Array<{_id: string, name: string}> | null = null;

const loginApiUrl = process.env.REACT_APP_API_URL ;


// Function to fetch suppliers from API and cache them
export const fetchAndCacheSuppliers = async (environment?: string): Promise<Array<{_id: string, name: string}>> => {
  // If environment is provided, clear cache to force refresh
  if (environment && cachedSuppliers) {
    cachedSuppliers = null;
  }
  
  if (cachedSuppliers) {
    return cachedSuppliers;
  }

  try {
    const response = await fetch(`${loginApiUrl}/suppliers/suppliers-for-reports-dashboard`, {
      headers: {
        'X-API-Key': process.env.REACT_APP_X_API_KEY || '',
        'username': process.env.REACT_APP_EXCEL_USERNAME || '',
        'password': process.env.REACT_APP_EXCEL_PASSWORD || ''
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch suppliers');
    }
    
    const data = await response.json();
    cachedSuppliers = data;
    return data;
  } catch (error) {
    console.error('Error fetching suppliers from API, falling back to hardcoded list:', error);
    // Convert SUPPLIERS to new format for fallback
    return SUPPLIERS.map(s => ({ _id: s.id, name: s.name }));
  }
};

// Synchronous versions for backward compatibility (will be deprecated)
export const getSupplierIdByNameSync = (name: string): string | undefined => {
  if (cachedSuppliers) {
    const supplier = cachedSuppliers.find(s => s.name === name);
    return supplier?._id;
  }
  // Fallback to hardcoded suppliers
  const supplier = SUPPLIERS.find(s => s.name === name);
  return supplier?.id;
};

export const getSupplierNameByIdSync = (id: string): string | undefined => {
  if (cachedSuppliers) {
    const supplier = cachedSuppliers.find(s => s._id === id);
    return supplier?.name;
  }
  // Fallback to hardcoded suppliers
  const supplier = SUPPLIERS.find(s => s.id === id);
  return supplier?.name;
};
